var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 13.054C27.2 21.964 16 29.6 16 29.6S4.8 21.963 4.8 13.054c0-3.038 1.18-5.951 3.28-8.1A11.075 11.075 0 0116 1.6c2.97 0 5.82 1.206 7.92 3.355a11.588 11.588 0 013.28 8.1z",
    stroke: "#00809C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.991 16.873c2.062 0 3.733-1.71 3.733-3.819 0-2.108-1.671-3.818-3.733-3.818-2.062 0-3.733 1.71-3.733 3.819 0 2.108 1.671 3.818 3.733 3.818z",
    stroke: "#00809C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3LjIgMTMuMDU0MkMyNy4yIDIxLjk2MzIgMTYgMjkuNTk5NiAxNiAyOS41OTk2QzE2IDI5LjU5OTYgNC43OTk5OSAyMS45NjMyIDQuNzk5OTkgMTMuMDU0MkM0Ljc5OTk5IDEwLjAxNjIgNS45Nzk5OCA3LjEwMjcxIDguMDgwMzkgNC45NTQ1N0MxMC4xODA4IDIuODA2NDIgMTMuMDI5NiAxLjU5OTYxIDE2IDEuNTk5NjFDMTguOTcwNCAxLjU5OTYxIDIxLjgxOTIgMi44MDY0MiAyMy45MTk2IDQuOTU0NTdDMjYuMDIgNy4xMDI3MSAyNy4yIDEwLjAxNjIgMjcuMiAxMy4wNTQyWiIgc3Ryb2tlPSIjMDA4MDlDIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS45OTExIDE2Ljg3MjdDMTguMDUzIDE2Ljg3MjcgMTkuNzI0NSAxNS4xNjMyIDE5LjcyNDUgMTMuMDU0NUMxOS43MjQ1IDEwLjk0NTggMTguMDUzIDkuMjM2MzMgMTUuOTkxMSA5LjIzNjMzQzEzLjkyOTMgOS4yMzYzMyAxMi4yNTc4IDEwLjk0NTggMTIuMjU3OCAxMy4wNTQ1QzEyLjI1NzggMTUuMTYzMiAxMy45MjkzIDE2Ljg3MjcgMTUuOTkxMSAxNi44NzI3WiIgc3Ryb2tlPSIjMDA4MDlDIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgIconLocation as ReactComponent };